<div class="client-profile-section">
  <div class="client-profile-overview-section">
    <img src="assets/user-profile.png" class="client-profile-image" />
    <p class="client-profile-name">
      {{ client_data.first_name }} {{ client_data.last_name }}
    </p>
    <p class="client-profile-id">({{ client_data.client_id }})</p>
    <div class="client-profile-member-section">
      <span class="client-profile-label">Member Since:</span>
      <span class="client-profile-value">{{
        client_data.member_since | date: "dd MMM yyyy"
      }}</span>
    </div>
  </div>
  <div class="client-profile-details-block">
    <div class="client-profile-details-section">
      <p class="client-profile-details-heading">Personal Information</p>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Email ID:</span>
        <span class="client-profile-value">{{ client_data.email }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Date of Birth:</span>
        <span class="client-profile-value">{{
          client_data.birth_date | date: "dd MMM yyyy"
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Gender:</span>
        <span class="client-profile-value">{{ client_data.gender }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Phone Number:</span>
        <span class="client-profile-value">{{
          client_data.telephone_number
        }}</span>
      </div>
    </div>
    <div class="client-profile-details-section">
      <p class="client-profile-details-heading">Contact Information</p>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Address:</span>
        <span class="client-profile-value">{{
          client_data.address_line_1
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">City:</span>
        <span class="client-profile-value">{{ client_data.city }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">State:</span>
        <span class="client-profile-value">{{ client_data.state }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Zip Code:</span>
        <span class="client-profile-value">{{ client_data.zip_code }}</span>
      </div>
    </div>
    <div class="client-profile-details-section">
      <p class="client-profile-details-heading">
        HouseHold & Behavioural Information
      </p>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Adults in Household:</span>
        <span class="client-profile-value">{{
          client_data.adults_in_household
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Children in Household:</span>
        <span class="client-profile-value">{{
          client_data.children_in_household
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Household Income Range({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{
          client_data.household_income_in_dollars
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Individual Income Range({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{
          client_data.individual_income_in_dollars
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Premium Credit Card Holder:</span>
        <span class="client-profile-value">
          <span *ngIf="client_data.premium_credit_card_holder">Yes</span>
          <span *ngIf="!client_data.premium_credit_card_holder">No</span>
        </span>
      </div>
    </div>
    <div class="client-profile-details-section">
      <p class="client-profile-details-heading">Other Info</p>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Vehicle Count:</span>
        <span class="client-profile-value">{{
          client_data.vehicle_count
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Home Equity({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{
          client_data.home_equity_available_for_mortgage_in_dollars
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Market Value({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{
          client_data.market_value_of_home_in_dollars
        }}</span>
      </div>

      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Liquid Net Worth({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{ client_data.net_worth }}</span>
      </div>

      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Total Net Worth({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{
          client_data.total_networth
        }}</span>
      </div>

      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Managed Money Revenue({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{
          client_data.money_managed_revenue
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Last Periodic Review Date:</span>
        <span class="client-profile-value">{{
          client_data.last_periodic_review_date | date: "dd MMM yyyy"
        }}</span>
      </div>

      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Last Contact Date:</span>
        <span class="client-profile-value">{{
          client_data.last_date_of_contact | date: "dd MMM yyyy"
        }}</span>
      </div>

      <!-- <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Confidence Flag:</span>
          <span class="client-profile-value">{{
            client_data.confidence_flag
          }}</span>
        </div> -->
    </div>
    <!-- <div class="client-profile-details-section">
          <p class="client-profile-details-heading">Client Goals</p>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Investment Purpose:</span>
            <span class="client-profile-value">{{client_data.investment_purpose}}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Target Amount({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
            <span class="client-profile-value">{{client_data.target_amount}}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Accomplished Target({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
            <span class="client-profile-value">{{client_data.accomplished_target}}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Investment goal tenure:</span>
            <span class="client-profile-value">{{client_data.investment_goal_tenure}}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Risk Tolerance:</span>
            <span class="client-profile-value">{{client_data.risk_tolerance}}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Other investments({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
            <span class="client-profile-value">{{client_data.other_investment}}</span>
          </div>
        </div> -->

    <div class="client-profile-details-section">
      <p class="client-profile-details-heading">Current Financial Situation</p>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Current Assets({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{
          client_data.current_assests
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Liabilities({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{ client_data.liabilities }}</span>
      </div>
      <!-- <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Income({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
            <span class="client-profile-value">{{
              client_data.individual_income_in_dollars
            }}</span>
          </div> -->
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Expenses({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{ client_data.expenses }}</span>
      </div>
    </div>
  </div>
</div>
<div class="client-products-section" *ngIf="client_data.existing_products">
  <div class="client-products-tabs-section">
    <div
      class="each-client-products-tab"
      [ngClass]="{
        'each-client-products-tab-selected': selected_tab == 'Existing Products'
      }"
      (click)="selected_tab = 'Existing Products'"
    >
      <span>Existing Products</span>
    </div>
  </div>
  <div *ngIf="selected_tab == 'Existing Products'">
    <div
      class="each-product-section"
      *ngFor="let product of client_data.existing_products"
    >
      <div class="each-product-heading-section">
        <span>{{ product.product_name }}(ID: {{ product.id }})</span>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Product Type</span>
          <span class="each-product-detail-value">{{
            product.product_type
          }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Financial Institution</span>
          <span class="each-product-detail-value">{{
            product.financial_institution
          }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Policy Number</span>
          <span class="each-product-detail-value">{{
            product.policy_number
          }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">AUM({{APP_CONSTANTS.CURRENCY_SYMBOL}})</span>
          <span class="each-product-detail-value">{{ product.amount }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Tenure(Years)</span>
          <span class="each-product-detail-value">{{ product.age }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Sale Type</span>
          <span class="each-product-detail-value">{{ product.type }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Maturity Date</span>
          <span
            class="each-product-detail-value"
            *ngIf="product.maturity_date != '' && product.maturity_date != null"
            >{{ product.maturity_date | date: "dd MMM yyyy" }}</span
          >
          <span
            class="each-product-detail-value"
            *ngIf="product.maturity_date == '' || product.maturity_date == null"
            >{{ product.maturity_date }}</span
          >
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Sold by</span>
          <span class="each-product-detail-value">{{ product.sold_by }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Status</span>
          <span class="each-product-detail-value">{{
            product.client_product_status_name
          }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
